import type { DocumentImageError } from '@onefootprint/request-types';

export type IdDocImageSide = 'front' | 'back' | 'selfie';
export const ID_DOC_SIDES = {
  front: 'front' as const,
  back: 'back' as const,
  selfie: 'selfie' as const,
};

export type SupportedIdDocType =
  | 'id_card'
  | 'drivers_license'
  | 'passport'
  | 'visa'
  | 'permit'
  | 'residence_document'
  | 'voter_identification'
  | 'ssn_card'
  | 'lease'
  | 'bank_statement'
  | 'utility_bill'
  | 'proof_of_address'
  | 'passport_card'
  | 'custom';

export type IdDocOutcome = 'pass' | 'fail' | 'real';

export const AUTH_HEADER = 'X-Fp-Authorization';

export type DocumentRequestKind = 'identity' | 'proof_of_ssn' | 'proof_of_address' | 'custom' | 'selfie';
export const DOC_REQUEST_KIND = {
  identity: 'identity' as const,
  proofOfSsn: 'proof_of_ssn' as const,
  proofOfAddress: 'proof_of_address' as const,
  custom: 'custom' as const,
  selfie: 'selfie' as const,
};

export enum IdDocImageUploadError {
  unknownUploadError = 'unknown_upload_error',
  multipleFilesError = 'multiple_files_error',
  fileTypeNotAllowed = 'file_type_not_allowed',
  heicNotSupported = 'heic_not_supported',
  networkError = 'network_error',
}

export type DocumentImageErrorType = DocumentImageError | IdDocImageUploadError | 'custom_error';

export type IdDocImageErrorType = {
  errorType: DocumentImageErrorType;
  errorInfo?: string;
};

export type CaptureKind = 'auto' | 'manual' | 'upload';

export type ReceivedImagePayload = {
  captureKind: CaptureKind;
  extraCompressed: boolean;
  imageFile: File | Blob;
  forcedUpload: boolean;
};

export type CameraErrorCause =
  | 'unsupported-browser'
  | 'undefined-navigator'
  | 'not-found'
  | 'already-in-use'
  | 'constraint'
  | 'permission-denied'
  | 'other-error';

/** Converts a HEIC or HEIF image to JPEG. */
export type HeicToModule = (options: { blob: Blob; quality?: number }) => Promise<Blob>;
